import { render, staticRenderFns } from "./modalAddressItems.vue?vue&type=template&id=596e7d56&scoped=true"
import script from "./modalAddressItems.vue?vue&type=script&lang=js"
export * from "./modalAddressItems.vue?vue&type=script&lang=js"
import style0 from "./modalAddressItems.vue?vue&type=style&index=0&id=596e7d56&prod&scoped=true&lang=css"
import style1 from "./modalAddressItems.vue?vue&type=style&index=1&id=596e7d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e7d56",
  null
  
)

export default component.exports